import React from "react";

import { reais } from "./formato";
import { formatarQtd } from "../../../lib/unidadeVenda";

const fmtPct = (v) => (v == null ? "—" : `${String(v).replace(".", ",")}%`);

export default function TabelaRanking({ ranking }) {
  return (
    <section>
      <h2 className="text-sm font-semibold mb-2">Por produto</h2>
      {(ranking || []).length === 0 ? (
        <p className="text-xs text-muted-foreground">Nenhuma oferta vista ou vendida no período.</p>
      ) : (
        <div className="overflow-x-auto rounded-xl border bg-card">
          <table className="w-full text-sm min-w-[520px]">
            <thead className="bg-muted/40 text-[11px] uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="text-left px-3 py-2">Produto</th><th className="text-right px-3 py-2">Vistas</th>
                <th className="text-right px-3 py-2">Vendidas</th><th className="text-right px-3 py-2">Desc. médio</th>
                <th className="text-right px-3 py-2">Receita</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {ranking.map((r) => (
                <tr key={r.chave}>
                  <td className="px-3 py-2">{r.nome}</td>
                  <td className="px-3 py-2 text-right tabular-nums">{r.vistas}</td>
                  <td className="px-3 py-2 text-right tabular-nums whitespace-nowrap">{formatarQtd(r.unidades, r.unidade)}</td>
                  <td className="px-3 py-2 text-right tabular-nums">{fmtPct(r.desconto_medio_pct)}</td>
                  <td className="px-3 py-2 text-right tabular-nums">{reais(r.receita)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
